    import config from "../../../../config";
    import { ResponseDto } from '../../../../dtos/common/responseDto';
    import { getData } from '../../../../utils/axios/serverHelper';
    import { formatDate } from '../../../../utils/string/stringUtil';
    import { SAL1030_R01Dto } from './Dto_SAL1030_R01';
    import { SAL1030_R01Filter } from './Store_SAL1030_R01';

    const baseUrl = `${config.apiUrl}/SAL1030_R01`;

    /**
     * 검색 파라미터 변환 함수
     */
    const getParams = (params: Partial<SAL1030_R01Filter>, listLength?: number) => {
    return {
        compCd: params?.compCd || '',
        startDate: params?.dateRange?.from ? formatDate(params.dateRange.from) : '',
        endDate: params?.dateRange?.to ? formatDate(params.dateRange.to) : '',
        customCd: params?.customCd || '',
        empNo: params?.empNo || '',
        listLength: listLength || 0
    };
    };

    /**
     * 품목별 수주 현황 목록 조회
     * @param option 검색 옵션 ('search', 'refetch', 또는 빈 문자열)
     * @param params 검색 조건
     * @param listLength 목록 길이
     * @returns 품목별 수주 현황 목록
     */
    export const getSAL1030_R01List = async (
    option: string,
    params: Partial<SAL1030_R01Filter>,
    listLength: number = 0
    ) => {
    // option이 빈 문자열이면 '/', 아니면 '/{option}'
    const url = option ? `${baseUrl}/${option}` : `${baseUrl}/`;
    return await getData<ResponseDto<SAL1030_R01Dto[]>>(url, { 
        params: getParams(params, listLength) 
    });
    };

    /**
     * 품목별 수주 현황 전체 개수 조회
     * @param params 검색 조건
     * @returns 전체 개수
     */
    export const getSAL1030_R01AllCount = async (
    params: Partial<SAL1030_R01Filter>
    ) => {
    const url = `${baseUrl}/allCount`;
    return await getData<ResponseDto<number>>(url, { 
        params: getParams(params, 0) 
    });
    };

    /**
     * 품목별 수주 현황 엑셀 다운로드
     * @param option 검색 옵션 ('search' 또는 빈 문자열)
     * @param params 검색 조건
     * @param listLength 목록 길이
     * @returns 엑셀 파일 데이터 (Base64 문자열)
     */
    export const downloadExcel_SAL1030_R01 = async (
    option: string,
    params: Partial<SAL1030_R01Filter>,
    listLength: number = 0
    ) => {
    // option이 'search'면 /excel/search, 아니면 /excel
    const url = option === 'search' ? `${baseUrl}/excel/search` : `${baseUrl}/excel`;
    const requestParams = getParams(params, undefined);
    
    return await getData<ResponseDto<string>>(url, {
        params: { ...requestParams, listLength } 
    });
    };
